/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MarketingRouteImport } from './routes/_marketing'
import { Route as FunnelRouteImport } from './routes/_funnel'
import { Route as AppRouteImport } from './routes/_app'
import { Route as MarketingIndexRouteImport } from './routes/_marketing.index'
import { Route as MarketingUpgradeRouteImport } from './routes/_marketing.upgrade'
import { Route as MarketingSupportRouteImport } from './routes/_marketing.support'
import { Route as MarketingScienceRouteImport } from './routes/_marketing.science'
import { Route as MarketingPrivacyRouteImport } from './routes/_marketing.privacy'
import { Route as MarketingOnboardingRouteImport } from './routes/_marketing.onboarding'
import { Route as MarketingAuthRouteImport } from './routes/_marketing.auth'
import { Route as AppUnlockRouteImport } from './routes/_app.unlock'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppRebalanceRouteImport } from './routes/_app.rebalance'
import { Route as AppGoalRouteImport } from './routes/_app.goal'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCompareRouteImport } from './routes/_app.compare'
import { Route as FunnelStartIndexRouteImport } from './routes/_funnel.start.index'
import { Route as AppSessionIndexRouteImport } from './routes/_app.session.index'
import { Route as FunnelStartVoiceRouteImport } from './routes/_funnel.start.voice'
import { Route as FunnelStartTongueRouteImport } from './routes/_funnel.start.tongue'
import { Route as FunnelStartScoresRouteImport } from './routes/_funnel.start.scores'
import { Route as FunnelStartPaywallRouteImport } from './routes/_funnel.start.paywall'
import { Route as FunnelStartImprovedRouteImport } from './routes/_funnel.start.improved'
import { Route as FunnelStartGoalRouteImport } from './routes/_funnel.start.goal'
import { Route as FunnelStartEmailRouteImport } from './routes/_funnel.start.email'
import { Route as FunnelStartCalibrateRouteImport } from './routes/_funnel.start.calibrate'
import { Route as FunnelStartBioscanRouteImport } from './routes/_funnel.start.bioscan'
import { Route as AppSessionPlayRouteImport } from './routes/_app.session.play'
import { Route as AppScanVoiceRouteImport } from './routes/_app.scan.voice'
import { Route as AppScanTongueRouteImport } from './routes/_app.scan.tongue'
import { Route as AppScanSweepRouteImport } from './routes/_app.scan.sweep'
import { Route as AppScanResultsRouteImport } from './routes/_app.scan.results'
import { Route as AppScanBioscanRouteImport } from './routes/_app.scan.bioscan'

const MarketingRoute = MarketingRouteImport.update({
  id: '/_marketing',
  getParentRoute: () => rootRouteImport,
} as any)
const FunnelRoute = FunnelRouteImport.update({
  id: '/_funnel',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketingIndexRoute = MarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingUpgradeRoute = MarketingUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingSupportRoute = MarketingSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingScienceRoute = MarketingScienceRouteImport.update({
  id: '/science',
  path: '/science',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingPrivacyRoute = MarketingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingOnboardingRoute = MarketingOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => MarketingRoute,
} as any)
const MarketingAuthRoute = MarketingAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => MarketingRoute,
} as any)
const AppUnlockRoute = AppUnlockRouteImport.update({
  id: '/unlock',
  path: '/unlock',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRebalanceRoute = AppRebalanceRouteImport.update({
  id: '/rebalance',
  path: '/rebalance',
  getParentRoute: () => AppRoute,
} as any)
const AppGoalRoute = AppGoalRouteImport.update({
  id: '/goal',
  path: '/goal',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCompareRoute = AppCompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => AppRoute,
} as any)
const FunnelStartIndexRoute = FunnelStartIndexRouteImport.update({
  id: '/start/',
  path: '/start/',
  getParentRoute: () => FunnelRoute,
} as any)
const AppSessionIndexRoute = AppSessionIndexRouteImport.update({
  id: '/session/',
  path: '/session/',
  getParentRoute: () => AppRoute,
} as any)
const FunnelStartVoiceRoute = FunnelStartVoiceRouteImport.update({
  id: '/start/voice',
  path: '/start/voice',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartTongueRoute = FunnelStartTongueRouteImport.update({
  id: '/start/tongue',
  path: '/start/tongue',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartScoresRoute = FunnelStartScoresRouteImport.update({
  id: '/start/scores',
  path: '/start/scores',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartPaywallRoute = FunnelStartPaywallRouteImport.update({
  id: '/start/paywall',
  path: '/start/paywall',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartImprovedRoute = FunnelStartImprovedRouteImport.update({
  id: '/start/improved',
  path: '/start/improved',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartGoalRoute = FunnelStartGoalRouteImport.update({
  id: '/start/goal',
  path: '/start/goal',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartEmailRoute = FunnelStartEmailRouteImport.update({
  id: '/start/email',
  path: '/start/email',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartCalibrateRoute = FunnelStartCalibrateRouteImport.update({
  id: '/start/calibrate',
  path: '/start/calibrate',
  getParentRoute: () => FunnelRoute,
} as any)
const FunnelStartBioscanRoute = FunnelStartBioscanRouteImport.update({
  id: '/start/bioscan',
  path: '/start/bioscan',
  getParentRoute: () => FunnelRoute,
} as any)
const AppSessionPlayRoute = AppSessionPlayRouteImport.update({
  id: '/session/play',
  path: '/session/play',
  getParentRoute: () => AppRoute,
} as any)
const AppScanVoiceRoute = AppScanVoiceRouteImport.update({
  id: '/scan/voice',
  path: '/scan/voice',
  getParentRoute: () => AppRoute,
} as any)
const AppScanTongueRoute = AppScanTongueRouteImport.update({
  id: '/scan/tongue',
  path: '/scan/tongue',
  getParentRoute: () => AppRoute,
} as any)
const AppScanSweepRoute = AppScanSweepRouteImport.update({
  id: '/scan/sweep',
  path: '/scan/sweep',
  getParentRoute: () => AppRoute,
} as any)
const AppScanResultsRoute = AppScanResultsRouteImport.update({
  id: '/scan/results',
  path: '/scan/results',
  getParentRoute: () => AppRoute,
} as any)
const AppScanBioscanRoute = AppScanBioscanRouteImport.update({
  id: '/scan/bioscan',
  path: '/scan/bioscan',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof MarketingIndexRoute
  '/compare': typeof AppCompareRoute
  '/dashboard': typeof AppDashboardRoute
  '/goal': typeof AppGoalRoute
  '/rebalance': typeof AppRebalanceRoute
  '/settings': typeof AppSettingsRoute
  '/unlock': typeof AppUnlockRoute
  '/auth': typeof MarketingAuthRoute
  '/onboarding': typeof MarketingOnboardingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/science': typeof MarketingScienceRoute
  '/support': typeof MarketingSupportRoute
  '/upgrade': typeof MarketingUpgradeRoute
  '/scan/bioscan': typeof AppScanBioscanRoute
  '/scan/results': typeof AppScanResultsRoute
  '/scan/sweep': typeof AppScanSweepRoute
  '/scan/tongue': typeof AppScanTongueRoute
  '/scan/voice': typeof AppScanVoiceRoute
  '/session/play': typeof AppSessionPlayRoute
  '/start/bioscan': typeof FunnelStartBioscanRoute
  '/start/calibrate': typeof FunnelStartCalibrateRoute
  '/start/email': typeof FunnelStartEmailRoute
  '/start/goal': typeof FunnelStartGoalRoute
  '/start/improved': typeof FunnelStartImprovedRoute
  '/start/paywall': typeof FunnelStartPaywallRoute
  '/start/scores': typeof FunnelStartScoresRoute
  '/start/tongue': typeof FunnelStartTongueRoute
  '/start/voice': typeof FunnelStartVoiceRoute
  '/session/': typeof AppSessionIndexRoute
  '/start/': typeof FunnelStartIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MarketingIndexRoute
  '/compare': typeof AppCompareRoute
  '/dashboard': typeof AppDashboardRoute
  '/goal': typeof AppGoalRoute
  '/rebalance': typeof AppRebalanceRoute
  '/settings': typeof AppSettingsRoute
  '/unlock': typeof AppUnlockRoute
  '/auth': typeof MarketingAuthRoute
  '/onboarding': typeof MarketingOnboardingRoute
  '/privacy': typeof MarketingPrivacyRoute
  '/science': typeof MarketingScienceRoute
  '/support': typeof MarketingSupportRoute
  '/upgrade': typeof MarketingUpgradeRoute
  '/scan/bioscan': typeof AppScanBioscanRoute
  '/scan/results': typeof AppScanResultsRoute
  '/scan/sweep': typeof AppScanSweepRoute
  '/scan/tongue': typeof AppScanTongueRoute
  '/scan/voice': typeof AppScanVoiceRoute
  '/session/play': typeof AppSessionPlayRoute
  '/start/bioscan': typeof FunnelStartBioscanRoute
  '/start/calibrate': typeof FunnelStartCalibrateRoute
  '/start/email': typeof FunnelStartEmailRoute
  '/start/goal': typeof FunnelStartGoalRoute
  '/start/improved': typeof FunnelStartImprovedRoute
  '/start/paywall': typeof FunnelStartPaywallRoute
  '/start/scores': typeof FunnelStartScoresRoute
  '/start/tongue': typeof FunnelStartTongueRoute
  '/start/voice': typeof FunnelStartVoiceRoute
  '/session': typeof AppSessionIndexRoute
  '/start': typeof FunnelStartIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_funnel': typeof FunnelRouteWithChildren
  '/_marketing': typeof MarketingRouteWithChildren
  '/_app/compare': typeof AppCompareRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/goal': typeof AppGoalRoute
  '/_app/rebalance': typeof AppRebalanceRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/unlock': typeof AppUnlockRoute
  '/_marketing/auth': typeof MarketingAuthRoute
  '/_marketing/onboarding': typeof MarketingOnboardingRoute
  '/_marketing/privacy': typeof MarketingPrivacyRoute
  '/_marketing/science': typeof MarketingScienceRoute
  '/_marketing/support': typeof MarketingSupportRoute
  '/_marketing/upgrade': typeof MarketingUpgradeRoute
  '/_marketing/': typeof MarketingIndexRoute
  '/_app/scan/bioscan': typeof AppScanBioscanRoute
  '/_app/scan/results': typeof AppScanResultsRoute
  '/_app/scan/sweep': typeof AppScanSweepRoute
  '/_app/scan/tongue': typeof AppScanTongueRoute
  '/_app/scan/voice': typeof AppScanVoiceRoute
  '/_app/session/play': typeof AppSessionPlayRoute
  '/_funnel/start/bioscan': typeof FunnelStartBioscanRoute
  '/_funnel/start/calibrate': typeof FunnelStartCalibrateRoute
  '/_funnel/start/email': typeof FunnelStartEmailRoute
  '/_funnel/start/goal': typeof FunnelStartGoalRoute
  '/_funnel/start/improved': typeof FunnelStartImprovedRoute
  '/_funnel/start/paywall': typeof FunnelStartPaywallRoute
  '/_funnel/start/scores': typeof FunnelStartScoresRoute
  '/_funnel/start/tongue': typeof FunnelStartTongueRoute
  '/_funnel/start/voice': typeof FunnelStartVoiceRoute
  '/_app/session/': typeof AppSessionIndexRoute
  '/_funnel/start/': typeof FunnelStartIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/compare'
    | '/dashboard'
    | '/goal'
    | '/rebalance'
    | '/settings'
    | '/unlock'
    | '/auth'
    | '/onboarding'
    | '/privacy'
    | '/science'
    | '/support'
    | '/upgrade'
    | '/scan/bioscan'
    | '/scan/results'
    | '/scan/sweep'
    | '/scan/tongue'
    | '/scan/voice'
    | '/session/play'
    | '/start/bioscan'
    | '/start/calibrate'
    | '/start/email'
    | '/start/goal'
    | '/start/improved'
    | '/start/paywall'
    | '/start/scores'
    | '/start/tongue'
    | '/start/voice'
    | '/session/'
    | '/start/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/compare'
    | '/dashboard'
    | '/goal'
    | '/rebalance'
    | '/settings'
    | '/unlock'
    | '/auth'
    | '/onboarding'
    | '/privacy'
    | '/science'
    | '/support'
    | '/upgrade'
    | '/scan/bioscan'
    | '/scan/results'
    | '/scan/sweep'
    | '/scan/tongue'
    | '/scan/voice'
    | '/session/play'
    | '/start/bioscan'
    | '/start/calibrate'
    | '/start/email'
    | '/start/goal'
    | '/start/improved'
    | '/start/paywall'
    | '/start/scores'
    | '/start/tongue'
    | '/start/voice'
    | '/session'
    | '/start'
  id:
    | '__root__'
    | '/_app'
    | '/_funnel'
    | '/_marketing'
    | '/_app/compare'
    | '/_app/dashboard'
    | '/_app/goal'
    | '/_app/rebalance'
    | '/_app/settings'
    | '/_app/unlock'
    | '/_marketing/auth'
    | '/_marketing/onboarding'
    | '/_marketing/privacy'
    | '/_marketing/science'
    | '/_marketing/support'
    | '/_marketing/upgrade'
    | '/_marketing/'
    | '/_app/scan/bioscan'
    | '/_app/scan/results'
    | '/_app/scan/sweep'
    | '/_app/scan/tongue'
    | '/_app/scan/voice'
    | '/_app/session/play'
    | '/_funnel/start/bioscan'
    | '/_funnel/start/calibrate'
    | '/_funnel/start/email'
    | '/_funnel/start/goal'
    | '/_funnel/start/improved'
    | '/_funnel/start/paywall'
    | '/_funnel/start/scores'
    | '/_funnel/start/tongue'
    | '/_funnel/start/voice'
    | '/_app/session/'
    | '/_funnel/start/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  FunnelRoute: typeof FunnelRouteWithChildren
  MarketingRoute: typeof MarketingRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_marketing': {
      id: '/_marketing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MarketingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_funnel': {
      id: '/_funnel'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof FunnelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_marketing/': {
      id: '/_marketing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MarketingIndexRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/upgrade': {
      id: '/_marketing/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof MarketingUpgradeRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/support': {
      id: '/_marketing/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof MarketingSupportRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/science': {
      id: '/_marketing/science'
      path: '/science'
      fullPath: '/science'
      preLoaderRoute: typeof MarketingScienceRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/privacy': {
      id: '/_marketing/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MarketingPrivacyRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/onboarding': {
      id: '/_marketing/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof MarketingOnboardingRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_marketing/auth': {
      id: '/_marketing/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof MarketingAuthRouteImport
      parentRoute: typeof MarketingRoute
    }
    '/_app/unlock': {
      id: '/_app/unlock'
      path: '/unlock'
      fullPath: '/unlock'
      preLoaderRoute: typeof AppUnlockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/rebalance': {
      id: '/_app/rebalance'
      path: '/rebalance'
      fullPath: '/rebalance'
      preLoaderRoute: typeof AppRebalanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/goal': {
      id: '/_app/goal'
      path: '/goal'
      fullPath: '/goal'
      preLoaderRoute: typeof AppGoalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/compare': {
      id: '/_app/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof AppCompareRouteImport
      parentRoute: typeof AppRoute
    }
    '/_funnel/start/': {
      id: '/_funnel/start/'
      path: '/start'
      fullPath: '/start/'
      preLoaderRoute: typeof FunnelStartIndexRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_app/session/': {
      id: '/_app/session/'
      path: '/session'
      fullPath: '/session/'
      preLoaderRoute: typeof AppSessionIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_funnel/start/voice': {
      id: '/_funnel/start/voice'
      path: '/start/voice'
      fullPath: '/start/voice'
      preLoaderRoute: typeof FunnelStartVoiceRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/tongue': {
      id: '/_funnel/start/tongue'
      path: '/start/tongue'
      fullPath: '/start/tongue'
      preLoaderRoute: typeof FunnelStartTongueRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/scores': {
      id: '/_funnel/start/scores'
      path: '/start/scores'
      fullPath: '/start/scores'
      preLoaderRoute: typeof FunnelStartScoresRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/paywall': {
      id: '/_funnel/start/paywall'
      path: '/start/paywall'
      fullPath: '/start/paywall'
      preLoaderRoute: typeof FunnelStartPaywallRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/improved': {
      id: '/_funnel/start/improved'
      path: '/start/improved'
      fullPath: '/start/improved'
      preLoaderRoute: typeof FunnelStartImprovedRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/goal': {
      id: '/_funnel/start/goal'
      path: '/start/goal'
      fullPath: '/start/goal'
      preLoaderRoute: typeof FunnelStartGoalRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/email': {
      id: '/_funnel/start/email'
      path: '/start/email'
      fullPath: '/start/email'
      preLoaderRoute: typeof FunnelStartEmailRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/calibrate': {
      id: '/_funnel/start/calibrate'
      path: '/start/calibrate'
      fullPath: '/start/calibrate'
      preLoaderRoute: typeof FunnelStartCalibrateRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_funnel/start/bioscan': {
      id: '/_funnel/start/bioscan'
      path: '/start/bioscan'
      fullPath: '/start/bioscan'
      preLoaderRoute: typeof FunnelStartBioscanRouteImport
      parentRoute: typeof FunnelRoute
    }
    '/_app/session/play': {
      id: '/_app/session/play'
      path: '/session/play'
      fullPath: '/session/play'
      preLoaderRoute: typeof AppSessionPlayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scan/voice': {
      id: '/_app/scan/voice'
      path: '/scan/voice'
      fullPath: '/scan/voice'
      preLoaderRoute: typeof AppScanVoiceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scan/tongue': {
      id: '/_app/scan/tongue'
      path: '/scan/tongue'
      fullPath: '/scan/tongue'
      preLoaderRoute: typeof AppScanTongueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scan/sweep': {
      id: '/_app/scan/sweep'
      path: '/scan/sweep'
      fullPath: '/scan/sweep'
      preLoaderRoute: typeof AppScanSweepRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scan/results': {
      id: '/_app/scan/results'
      path: '/scan/results'
      fullPath: '/scan/results'
      preLoaderRoute: typeof AppScanResultsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/scan/bioscan': {
      id: '/_app/scan/bioscan'
      path: '/scan/bioscan'
      fullPath: '/scan/bioscan'
      preLoaderRoute: typeof AppScanBioscanRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCompareRoute: typeof AppCompareRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppGoalRoute: typeof AppGoalRoute
  AppRebalanceRoute: typeof AppRebalanceRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppUnlockRoute: typeof AppUnlockRoute
  AppScanBioscanRoute: typeof AppScanBioscanRoute
  AppScanResultsRoute: typeof AppScanResultsRoute
  AppScanSweepRoute: typeof AppScanSweepRoute
  AppScanTongueRoute: typeof AppScanTongueRoute
  AppScanVoiceRoute: typeof AppScanVoiceRoute
  AppSessionPlayRoute: typeof AppSessionPlayRoute
  AppSessionIndexRoute: typeof AppSessionIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCompareRoute: AppCompareRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppGoalRoute: AppGoalRoute,
  AppRebalanceRoute: AppRebalanceRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppUnlockRoute: AppUnlockRoute,
  AppScanBioscanRoute: AppScanBioscanRoute,
  AppScanResultsRoute: AppScanResultsRoute,
  AppScanSweepRoute: AppScanSweepRoute,
  AppScanTongueRoute: AppScanTongueRoute,
  AppScanVoiceRoute: AppScanVoiceRoute,
  AppSessionPlayRoute: AppSessionPlayRoute,
  AppSessionIndexRoute: AppSessionIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface FunnelRouteChildren {
  FunnelStartBioscanRoute: typeof FunnelStartBioscanRoute
  FunnelStartCalibrateRoute: typeof FunnelStartCalibrateRoute
  FunnelStartEmailRoute: typeof FunnelStartEmailRoute
  FunnelStartGoalRoute: typeof FunnelStartGoalRoute
  FunnelStartImprovedRoute: typeof FunnelStartImprovedRoute
  FunnelStartPaywallRoute: typeof FunnelStartPaywallRoute
  FunnelStartScoresRoute: typeof FunnelStartScoresRoute
  FunnelStartTongueRoute: typeof FunnelStartTongueRoute
  FunnelStartVoiceRoute: typeof FunnelStartVoiceRoute
  FunnelStartIndexRoute: typeof FunnelStartIndexRoute
}

const FunnelRouteChildren: FunnelRouteChildren = {
  FunnelStartBioscanRoute: FunnelStartBioscanRoute,
  FunnelStartCalibrateRoute: FunnelStartCalibrateRoute,
  FunnelStartEmailRoute: FunnelStartEmailRoute,
  FunnelStartGoalRoute: FunnelStartGoalRoute,
  FunnelStartImprovedRoute: FunnelStartImprovedRoute,
  FunnelStartPaywallRoute: FunnelStartPaywallRoute,
  FunnelStartScoresRoute: FunnelStartScoresRoute,
  FunnelStartTongueRoute: FunnelStartTongueRoute,
  FunnelStartVoiceRoute: FunnelStartVoiceRoute,
  FunnelStartIndexRoute: FunnelStartIndexRoute,
}

const FunnelRouteWithChildren =
  FunnelRoute._addFileChildren(FunnelRouteChildren)

interface MarketingRouteChildren {
  MarketingAuthRoute: typeof MarketingAuthRoute
  MarketingOnboardingRoute: typeof MarketingOnboardingRoute
  MarketingPrivacyRoute: typeof MarketingPrivacyRoute
  MarketingScienceRoute: typeof MarketingScienceRoute
  MarketingSupportRoute: typeof MarketingSupportRoute
  MarketingUpgradeRoute: typeof MarketingUpgradeRoute
  MarketingIndexRoute: typeof MarketingIndexRoute
}

const MarketingRouteChildren: MarketingRouteChildren = {
  MarketingAuthRoute: MarketingAuthRoute,
  MarketingOnboardingRoute: MarketingOnboardingRoute,
  MarketingPrivacyRoute: MarketingPrivacyRoute,
  MarketingScienceRoute: MarketingScienceRoute,
  MarketingSupportRoute: MarketingSupportRoute,
  MarketingUpgradeRoute: MarketingUpgradeRoute,
  MarketingIndexRoute: MarketingIndexRoute,
}

const MarketingRouteWithChildren = MarketingRoute._addFileChildren(
  MarketingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  FunnelRoute: FunnelRouteWithChildren,
  MarketingRoute: MarketingRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
